import { IExportImportClient } from "@multiweb/clients/exportImport";
import { ICommunicationManager } from "../../../ICommunicationManager";
import { ExportImportClient } from "./exportImportClient";

export function defaultFactory(communicationManager: ICommunicationManager): IExportImportClient {
    return new ExportImportClient(communicationManager);
}
